/**
 *
 * @file Navigation functionality
 * @copyright JG Media Limited
 * @author JG Media
 * @version 1.0
 * @module core-nav
 *
 */

/**
 * @function
 * @name Anonymous self-invoked function
 * @param {Object} $ jQuery
 */
(function ($) {

	/**
	 * mobile nav trigger
	 * @function
	 * @name mobileNavTrigger
	 */
	coreVariables.mobileNavTrigger = function () {

		var navTrigger = jQuery('#mobile-nav-trigger'),
			html = jQuery('html'),
			mobileNav = jQuery('#mobile-nav-wrapper');

		if (navTrigger) {

			navTrigger.click(function () {

				html.toggleClass('mobile-nav-open');

				if (html.hasClass('mobile-nav-open')) {

					setTimeout(function () {

						mobileNav.focus();
						mobileNav.click();

					}, 300);

					document.getElementById('mobile-nav-wrapper').scrollTop = 0;

				} else {

					//close the open accordions
					// jQuery('.core-mega-nav-subcategory-menu, .sub-menu').hide();
					// jQuery('.fa-minus').addClass('fa-plus').removeClass('fa-minus');

				}

			});

		}

	}

	/**
	 * mobile & desktop nav switching functionality
	 * @function
	 * @name navSwitch
	 */
	coreVariables.navSwitch = function () {

		if (document.documentElement.clientWidth < coreVariables.breakpoints[coreVariables.mobileNavBreakpoint]) {

			//put the desktop nav into mobile
			jQuery('#mobile-nav').append(jQuery('#desktop-nav').contents());
			jQuery('#mobile-mega-nav').append(jQuery('#core-mega-nav-outer'));

			console.log('CORE: nav switching to MOBILE mode');

		} else {

			//put the mobile nav into desktop
			jQuery('#desktop-nav').append(jQuery('#mobile-nav').contents());
			jQuery('#mega-nav-section').append(jQuery('#mobile-mega-nav').contents());
			jQuery('html').removeClass('mobile-nav-open');

			console.log('CORE: nav switching to DESKTOP mode');

		}

	}

	/**
	 * create currency switcher pop
	 * @function
	 * @name currencySwitcher
	 * @deprecated
	 */
	/* coreVariables.currencySwitcher = function() {

		var currencySwitches = jQuery('.core-change-currency');

		if (currencySwitches) {

			currencySwitches.each(function(index) {

				var target = this,
					pop = document.querySelector('#core-currency-switch-wrapper');

				if (typeof(Popper) !== 'undefined' && target.length > 0) {

					coreVariables.currencyPop = coreVariables.currencyPop || {};

					var settings = {

						placement: 'auto',
						eventsEnabled: false,

						onCreate: function() {

							console.log('CORE: currency pop created');

						}

					}

					if (coreVariables.viewPortWidth < coreVariables.breakpoints[coreVariables.mobileNavBreakpoint]) {

						settings.placement = 'right';

					}

					coreVariables.currencyPop[index] = new Popper(target, pop, settings);

					target.on('click', function(){

						jQuery('.pop').not(this).hide();
						pop.toggle();
						coreVariables.currencyPop[index].update();
						console.log('CORE: currencyPop ' + index + ' updated');

					});

					// target.on('blur', function(e){

					//     debugger;
					//     pop.toggle();


					// });

				} else {

					console.log('CORE: popper not available when currencySwitcher function called or target not found');
				}

			})

		}

	}*/

	/**
	 * mega nav functionality
	 * @function
	 * @name megaNav
	 */
	coreVariables.megaNav = function () {

		if (document.getElementById('core-mega-nav-outer')) {

			//MOBILE

			//detect if the nav trigger is visible
			if (jQuery('#mobile-nav-trigger').is(':visible')) {

				//if already in mobile mode, do nothing
				if (coreVariables.megaNavState == 'mobile') {

					return;

				}

				console.log('CORE: MOBILE mega nav triggered');

				//add expanding markup to editorial menus (mage nav menu buttons are set via php)
				var expandMarkup = '<div class="mega-nav-mobile-expand"><i class="fas fa-plus"></i></div>';
				jQuery('#core-mega-nav').find('.menu-item-has-children > a').after(expandMarkup);

				//expanding nav
				jQuery('.mega-nav-mobile-expand').click(function () {

					//reveal the top level menu items
					// console.log(jQuery(this).siblings('.core-mega-nav-subcategory-menu, .sub-menu').first());

					console.log(jQuery(this).parent().find('ul').first());
					jQuery(this).parent().find('ul').first().slideToggle();

					jQuery(this).find('i').toggleClass('fa-plus fa-minus');

				});

				//remove the desktop event listeners
				if (coreVariables.megaNavPopper) {
					coreVariables.megaNavPopper.destroy();
				}

				var menuItems = jQuery('#core-mega-nav>ul>li'),
					navWrapper = jQuery('#core-mega-nav-wrapper');

				//remove desktop event listeners
				menuItems.unbind('mouseenter');
				navWrapper.unbind('mouseleave');

				coreVariables.megaNavState = 'mobile';

			}

			//DESKTOP
			else {

				//if already in desktop mode, do nothing
				if (coreVariables.megaNavState == 'desktop') {

					return;

				}

				console.log('CORE: DESKTOP mega nav triggered');

				var menuContent,
					menuContentClone,
					popper,
					navWrapper = jQuery('#core-mega-nav-wrapper'),
					navWindow = document.getElementById('core-mega-nav-window'),
					navWindowContent = jQuery('#core-mega-nav-window-content'),
					menuItems = jQuery('#core-mega-nav>ul>li'), //the first list item is the visible menu
					arrow = document.getElementById('core-mega-nav-arrow'),

					popperOptions = {

						eventsEnabled: false,
						position: 'bottom',

						modifiers: {
							flip: {
								behavior: ['bottom']
							}
						}

					};

				//add the ability to tab to the menu items
				// menuItems.each(function(){jQuery(this).attr('tabindex', 0)})

				menuItems.on('mouseenter', function () {

					console.log('CORE: mega nav hover');

					//if an editorial menu
					if (jQuery(this).parent().hasClass('editorial-menu')) {

						//grab the top level list only (sub menus are nested)
						menuContent = jQuery(this).find('ul').first();

					}
					//else a category menu
					else {

						//grab all the list items (taxonomy menus are at the top level)
						menuContent = jQuery(this).find('ul');

					}

					if (menuContent.length > 0) {

						menuContentClone = menuContent.clone();
						navWindowContent.html(menuContentClone);
						navWindow.classList.add('open');

						coreVariables.megaNavPopper = new Popper(this, navWindow, popperOptions);

					} else {

						navWindow.classList.remove('open');

						if (popper) {

							coreVariables.megaNavPopper.destroy();

						}
					}

				});

				navWrapper.on('mouseleave', function () {

					navWindow.classList.remove('open');

					if (popper) {

						coreVariables.megaNavPopper.destroy();

					}

				});

				//remove the mobile event listeners (will be reset when mobile mode triggered)
				jQuery('.mega-nav-mobile-expand').unbind('click');

				coreVariables.megaNavState = 'desktop';

			}

			jQuery('#core-mega-nav-outer').show();

		}

	}

	/**
	 * @listens document.ready
	 * @description various functions to fire on document ready
	 * @event document/ready
	 */
	jQuery(document).ready(function () {

		//fire up the mobile nav
		coreVariables.mobileNavTrigger();

		//put the nav content in the right place
		coreVariables.navSwitch();

		//only use if popper is enabled
		if (coreVariables.enablePopper) {

			//add the tooltip to the login menu item
			if(typeof coreVariables.loginDropDown === 'function') coreVariables.loginDropDown();

		}

		//currency switcher - deprecated
		//coreVariables.currencySwitcher();

		if (coreVariables.enableMegaNav) {

			//fire up the mega nav
			coreVariables.megaNav();

		}

		jQuery('#mobile-nav-wrapper').show();

	});

})(jQuery);